// Note: vue-tour is Vue 2 only. Consider using v-tour for Vue 3
// Install: npm install v-tour@next
import Vue3Tour from 'vue3-tour'

import 'vue3-tour/dist/vue3-tour.css'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(Vue3Tour)
})
